export default __webpack_public_path__ + "static/media/main pic.5559ed21.jpg";